import expediaLogo from './assets/logos/expedia.png';
import gamestopLogo from './assets/logos/gamestop.png';
import homedepotLogo from './assets/logos/homedepot.png';
import petcoLogo from './assets/logos/petco.png';
import staplesLogo from './assets/logos/staples.png';
import wallmartLogo from './assets/logos/wallmart.png';
import disneylandLogo from './assets/logos/disneyland.png';

import persona1 from './assets/persons/persona1.png';
import persona2 from './assets/persons/persona2.png';
import persona3 from './assets/persons/persona3.png';

export const list = [
	{ title: 'Wallmart', logo: wallmartLogo },
	{ title: 'Expedia', logo: expediaLogo },
	{ title: 'GameStop', logo: gamestopLogo },
	{ title: 'HomeDepot', logo: homedepotLogo },
	{ title: 'Staples', logo: staplesLogo },
	{ title: `Petco`, logo: petcoLogo },
	{
		title: `Disneyland`,
		logo: disneylandLogo,
	},
];

export const reviews = [
	{
		user_img: persona1,
		name: 'Alex C.',
		message: `“So I've only used this app for an entire year & I am impressed at it. You take like 10 minutes to look at what's available, you can plan your meals & save a lot of money. Thanks Live Rewards!”`,
	},
	{
		user_img: persona2,
		name: 'Jessica F.',
		message: `As a stay-at-home mom, I am so thankful for Live Rewards because it helps us stretch our grocery budget, put money away for vacations and help others all at the same time!`,
	},
	{
		user_img: persona3,
		name: 'Devon L.',
		message: `I've been using the Live Rewards App like a mad woman at the Home Depot and Lowe's. House renovations are killer. A vacation would be lovely! Thanks Live Rewards!`,
	},
];
